import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-reels",
  imports: [],
  templateUrl: "./icon-reels.component.html",
  styleUrl: "./icon-reels.component.scss",
})
export class IconReelsComponent {
  @Input() color = "#000";
}
